export enum ComplaintSource {
  /**
   * 录入
   */
  ENTRY = 0,

  /**
   * 投诉
   */
  COMPLAINT = 1
}

export const ComplaintSourceTextMap = {
  [ComplaintSource.ENTRY]: '录入',
  [ComplaintSource.COMPLAINT]: '投诉'
}
